import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  paymentPlanType: '',
  instalmentPlanList: [],
  buyers: [],
  broker: {},
  brokerDetails: {},
  contractDetails: {},
  representativeDetails: [],
  documents: [],
  property: {},
  breakdown: {},
  sellerDetails: {},
  companiesResponse: {},
  usersResponse: {},
  currentBuyerDocuments: [],
  // --------------- previous work ------------- //
  applicationInitalData: {},
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  updatePercentbuyer: [],
  propertyDetails: null,
};

// eslint-disable-next-line consistent-return
export default function offPlanReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.OFFPLAN_BUY_SELL_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.OFFPLAN_BUY_SELL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.OFFPLAN_BUY_SELL_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.OFFPLAN_BUY_SELL_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.OFFPLAN_BUY_SELL_CLEAR_APPLICATION:
      return {
        ...defaultState,
      };

    case types.OFFPLAN_BUY_SELL_FETCH_PROPERTY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        propertyDetails: action.payload,
      };

    case types.OFFPLAN_BUY_SELL_FETCH_APPLICATION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        paymentPlanType: get(action.payload, 'paymentPlanType', []),
        instalmentPlanList: get(action.payload, 'instalmentPlanList', []),
        buyers: get(action.payload, 'buyers', []),
        broker: get(action.payload, 'broker', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
        representativeDetails: get(action.payload, 'representativeDetails', []),
      };

    case types.OFFPLAN_BUY_SELL_DELETE_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        broker: {},
      };
    }

    case types.OFFPLAN_BUY_SELL_ADD_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', state.documents),
      };
    }

    case types.OFFPLAN_BUY_SELL_SET_BUYER_TRANSACTION_PERCENTAGE:
      const updatedBuyers = state?.buyers?.map(buyer => {
        if (
          (action?.data?.isUser && buyer?.id === action?.data?.id) ||
          (action?.data?.isCompany && buyer?.id === action?.data?.id)
        ) {
          return {
            ...buyer,
            transactionShare: action?.data?.transactionShare,
          };
        }

        return buyer;
      });
      return {
        ...state,
        buyers: updatedBuyers,
      };

    case types.OFFPLAN_BUY_SELL_SAVE_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.OFFPLAN_BUY_SELL_CHANGE_WORKFLOW_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };

    case types.OFFPLAN_BUY_SELL_FETCH_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        breakdown: get(action.payload, 'breakdown', []),
      };
    // case types.RESET_BREAKDOWN_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: null,
    //     breakdown: null,
    //   };
    case types.OFFPLAN_BUY_SELL_FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };

    case types.OFFPLAN_BUY_SELL_FIELD_CHANGE:
      if (action.payload.object) {
        return {
          ...state,
          application: {
            ...state.application,
            [action.payload.object]: {
              ...state.application[action.payload.object],
              // [action.payload.name]: action.payload.value,
              ...action.payload.valueObject,
            },
          },
        };
      }
      break;
    case types.OFFPLAN_BUY_SELL_FORM_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.OFFPLAN_BUY_SELL_FETCH_GOVERNMENT_COMPANIES_SUCCESS:
      return {
        ...state,
        loading: false,
        companiesResponse: get(action.payload, 'companiesResponse', {}),
      };
    case types.OFFPLAN_BUY_SELL_CLEAR_GOVERNMENT_COMPANIES:
      return {
        ...state,
        companiesResponse: {},
      };
    case types.OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS:
      return {
        ...state,
        loading: true,
        usersResponse: {},
      };
    case types.OFFPLAN_BUY_SELL_FETCH_NON_UAE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        usersResponse: get(action.payload, 'usersResponse', {}),
      };

    // --------------- previous work ------------- //

    case types.FETCH_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.INITIATE_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.DELETE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        instalmentPlanList: [],
        loading: false,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DELETE_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_OFFPLAN_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        brokers: get(action.payload, 'brokers', []),
      };
    }
    case types.DELETE_OFFPLAN_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.FETCH_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        representativeDetails: get(action.payload, 'representativeDetails', []),
      };
    case types.ADD_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.MUSATAHA_CHANGE_APPLICATION_STEP:
      return {
        ...state,
        activeStep: action?.payload,
      };
    case types.CHANGE_OFF_PLAN_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.OFFPLAN_VALIDATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.UPLOAD_MUSATAHA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_MUSATAHA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.MUSATAHA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.MUSATAHA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetails: {
          ...state.contractDetails,
          [action.payload.key]: action.payload.value,
        },
      };
    case types.SET_BUYER_DETAIL:
      return {
        ...state,
        updatePercentbuyer: [...state.buyers],
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
